import React from "react";
//#region types
import { QualifiedShareDividendStatusTagsProps } from "models/propTypes/qualifiedShareDividendsPropTypes";
//#endregion
//#region components
import { Tags } from "components/common";
import { useQualifiedShareDividendsService } from "serviceHooks";
//#endregion

const QualifiedShareDividendStatusTags: React.FC<QualifiedShareDividendStatusTagsProps> = (props) => {
  const qualifiedShareDividendsService = useQualifiedShareDividendsService();
  return (
    <Tags
      tags={[qualifiedShareDividendsService.getStateText(props.status)]}
      className={qualifiedShareDividendsService.getStateLabelClass(props.status)}
    />
  );
};

export default QualifiedShareDividendStatusTags;
